import { polyfill } from "es6-promise";
polyfill();

import Vue from "vue";
import Vuex from "vuex";

const state = {
  page_state: 0, //possible values: 0, 1, 2, 21 (21 is mobile)
  popup_state: "",
  popup_video_src: "",
  can_skip_videos: true,
  popup_img_src: "",
  unity_progress: 0,
  unity_info: "",
  form_status: 0,
  contact_form_status: 0,

  ambience_volume: 0.17,
  ambience_max_volume: 0.17,
  ambience_current_vol: 0,
  ambience_previous_vol: -1,
  voice_volume: 1,

  instructions_shown: false,

  sections: [],

  sections_content: {
    event_info: {
      tag: "supernus"
    },
    ADHD: {
      subids: {
        ADHD_Tumbler_1: {
          type: "image",
          src: "ADHD_Tumbler_1.png",
          link: "https://www.team-adhd.com/adhd-and-comorbidities/?utm_source=conference&utm_medium=virtual%20hub&utm_campaign=tumbler1",
          extra_css_class: "circle_popup"
        },
        ADHD_Tumbler_2: {
          type: "image",
          src: "ADHD_Tumbler_2.png",
          link: "https://www.team-adhd.com/adhd-and-comorbidities/differential-diagnosis/?utm_source=conference&utm_medium=virtual%20hub&utm_campaign=tumbler2",
          extra_css_class: "circle_popup"
        },
        ADHD_Tumbler_3: {
          type: "image",
          src: "ADHD_Tumbler_3.png",
          link:
            "https://www.team-adhd.com/adhd-treatment/?utm_source=conference&utm_medium=virtual%20hub&utm_campaign=tumbler3",
          extra_css_class: "circle_popup"
        },
        ADHD_Tumbler_4: {
          type: "image",
          src: "ADHD_Tumbler_4.png",
          link: "https://www.team-adhd.com/adhd-psychiatric-comorbidities/developmental-disorders/?utm_source=conference&utm_medium=virtual%20hub&utm_campaign=tumbler4",
          extra_css_class: "circle_popup"
        },
        ADHD_LeftPanel: {
          type: "image",
          src: "ADHD_LeftPanel.jpg",
          link: "https://www.team-adhd.com/complex-adhd/?utm_source=conference&utm_medium=virtual%20hub&utm_campaign=booth",
          extra_css_class: "top_right_close"
        },
        ADHD_RightPanel: {
          type: "faces",
          src: "ADHD_RightPanel.png",
          title: "Team ADHD",
          list: [
            {
              type: "internal_face",
              src: "ADHD_RightPanel_Face01_Popup.png",
              link: "https://www.moretoadhd.com/adhd-resources/?utm_source=conference&utm_medium=virtual%20hub&utm_campaign=cutler%20video%20series#videos",
              thumb: "adhd_btn_1.jpg"
            },
            {
              type: "internal_face",
              src: "ADHD_RightPanel_Face02_Popup.png",
              link:
                "https://www.team-adhd.com/disease-state-education-for-caregivers/disease-state-education-for-healthcare-providers?utm_source=conference&utm_medium=virtual%20hub&utm_campaign=jain%20video#treating-comorbid-complex-adhd",
              thumb: "adhd_btn_2.jpg"
            },
            {
              type: "internal_face",
              src: "ADHD_RightPanel_Face03_Popup.png",
              link: "https://www.team-adhd.com/complex-adhd/?utm_source=conference&utm_medium=virtual%20hub&utm_campaign=childress%20quote",
              thumb: "adhd_btn_3.jpg"
            },
            {
              type: "internal_face",
              src: "ADHD_RightPanel_Face04_Popup.png",
              link:
                "https://www.team-adhd.com/disease-state-education-for-caregivers/disease-state-education-for-healthcare-providers?utm_source=conference&utm_medium=virtual%20hub&utm_campaign=mattingly%20video#serious-impairments-adhd",
              thumb: "adhd_btn_4.jpg"
            },
            {
              type: "internal_face",
              src: "ADHD_RightPanel_Face05_Popup.png",
              link:
                "https://www.team-adhd.com/adhd-psychiatric-comorbidities/mood-disorders/?utm_source=conference&utm_medium=virtual%20hub&utm_campaign=cerulli%20quote",
              thumb: "adhd_btn_5.jpg"
            },
            {
              type: "internal_face",
              src: "ADHD_RightPanel_Face06_Popup.png",
              link:
                "https://www.team-adhd.com/disease-state-education-for-caregivers/disease-state-education-for-healthcare-providers/?utm_source=conference&utm_medium=virtual%20hub&utm_campaign=maletic%20video#neurobiology-adhd",
              thumb: "adhd_btn_6.jpg"
            },
            {
              type: "internal_face",
              src: "ADHD_RightPanel_Face07_Popup.png",
              link: "https://www.team-adhd.com/complex-adhd/diagnosis-adhd/?utm_source=conference&utm_medium=virtual%20hub&utm_campaign=voegels%20quote",
              thumb: "adhd_btn_7.jpg"
            },
            {
              type: "internal_face",
              src: "ADHD_RightPanel_Face08_Popup.png",
              link: "https://www.team-adhd.com/complex-adhd/sdbp-guidelines/?utm_source=conference&utm_medium=virtual%20hub&utm_campaign=lopez%20quote",
              thumb: "adhd_btn_8.jpg"
            },
            {
              type: "internal_face",
              src: "ADHD_RightPanel_Face09_Popup.png",
              thumb: "adhd_btn_9.jpg",
              link: "https://vimeopro.com/user9684004/comorbid-complex-adhd-challenges-to-diagnosis-and-treatment"
            }
          ]
          // link: ""
        }
      }
    },

    CNS: {
      subids: {
        CNS_Tumbler_1: {
          type: "image",
          src: "CNS_Tumbler_1.jpg",
          extra_css_class: "top_right_close"
        },
        CNS_Tumbler_2: {
          type: "brochure",
          src: "CNS_Tumbler_2.jpg",
          extra_css_class: "top_right_close",
          links: {
            b1: "https://www.moretoadhd.com/adhd-resources/?utm_source=conference&utm_medium=virtual%20hub&utm_campaign=consumer%20adhd%20resources#downloadable-resources#TBDjumpdown",
            b2:
              "https://www.team-adhd.com/disease-state-education-for-caregivers/disease-state-education-for-healthcare-providers?utm_source=conference&utm_medium=virtual%20hub&utm_campaign=clinical%20newsletter#team-adhd-updates",
            b3:
              "https://www.team-adhd.com/caregiver-education/disease-state-education-for-healthcare-providers/?utm_source=conference&utm_medium=virtual%20hub&utm_campaign=neurobiology%20of%20adhd%20resource#additional-resources-adhd"
          }
        },
        CNS_LeftPanel: {
          type: "image",
          src: "CNS_LeftPanel.jpg",
          extra_css_class: "top_right_close small_close"
        },
        CNS_RightPanel: {
          type: "image",
          src: "CNS_RightPanel.jpg"
          // link: ""
        }
      }
    },
    MA: {
      subids: {
        MA_Panel: {
          type: "image",
          src: "MA_Panel.png",
          link: "https://www.supernus.com"
        },
        MA_Tumbler_1: {
          type: "form",
          src: "MA_Tumbler_1_1.jpg",
          extra_css_class: "form-popup top_right_close"
        },
        MA_Popup: {
          type: "image",
          src: "MA_Popup.jpg",
          extra_css_class: "full_close"
        }
      }
    },
    Btn: {
      subids: {
        Btn_moreInfo: {
          type: "form",
          src: "Btn_moreInfo_1.jpg",
          extra_css_class: "form-popup top_right_close"
        }
      }
    }
  },

  footer_additional_links: [],

  current_section: "",
  current_sub_section: "",

  current_secondary_section: "",
  current_secondary_sub_section: "",

  app_state: -1,
  initial_movement_mode: "AUTO",
  app_type: "mobile",

  booth_form: {
    name: "",
    lastname: "",
    email: "",
    country: "",
    specialty: ""
  },

  browser: null,
  browser_is_mobile: false,

  //general site options, be careful with this
  site_config: {
    use_intro_image: true,
    use_intro_video: false,
    use_intro_form: false,
    use_footer_as_links: false,
    validate_form: true,
    fake_mobile: false
  }
};

const mutations = {
  SET_PAGE_STATE(state, val) {
    state.page_state = val;
  },
  SET_POPUP_STATE(state, val) {
    console.log("set_popup_state", val);
    state.popup_state = val;
  },
  SET_UNITY_PROGRESS(state, val) {
    state.unity_progress = val;
  },
  SET_UNITY_INFO(state, val) {
    state.unity_info = val;
  },
  SET_FORM_STATUS(state, val) {
    state.form_status = val;
  },
  SET_CONTACT_FORM_STATUS(state, val) {
    state.contact_form_status = val;
  },
  SET_VIDEO_POPUP(state, val) {
    state.popup_video_src = val;
    state.popup_state = "video";
  },
  SET_IMAGE_POPUP(state, val) {
    state.popup_img_src = val;
    state.popup_state = "image";
  },
  SET_SLIDESHOW_POPUP(state, val) {
    state.popup_video_src = val;
    state.popup_state = "slideshow";

    console.log(state);
  },
  SET_LINKS_POPUP(state, val) {
    state.popup_video_src = val;
    state.popup_state = "links";
  },
  SET_CONTACT_POPUP(state, val) {
    state.popup_video_src = val;
    state.popup_state = "form";
  },
  SET_ACTIVE_SECTION(state, val) {
    console.log("setting active section to ", val);
    state.current_section = val + "";
    state.current_secondary_section = "";
  },
  SET_ACTIVE_SUB_SECTION(state, val) {
    console.log("setting active subsection to ", val);
    state.current_sub_section = val + "";
    state.current_secondary_sub_section = "";
  },
  SET_SECONDARY_SECTION(state, val) {
    state.current_secondary_section = val.section;
    state.current_secondary_sub_section = val.sub_section;
  },
  SET_APP_STATE(state, val) {
    state.app_state = val;
  },

  SET_SIMPLE_VAL(state, obj) {
    state[obj.name] = obj.val;
  },
  SAVE_BOOTH_FORM(state, obj) {
    state.booth_form = JSON.parse(JSON.stringify(obj));
    state.form_status = 1;
  },

  SAVE_INITIAL_MOVEMENT_FORM(state, app_mode) {
    state.initial_movement_mode = app_mode;
    console.log("initial app mode", state.initial_movement_mode);
  },

  SET_BROWSER_IDENTITY(state, browser) {
    state.browser = browser;
  },

  SET_VOICEOVER_PLAYED(state, section) {
    state.sections.forEach((item, idx) => {
      //other voiceover might be playing so let's stop them
      if (item.has_voiceover && item.id == section + "") {
        item.voiceover_has_played = true;
      }
    });
  }
};

const actions = {
  set_page_state({ commit }, val) {
    commit("SET_PAGE_STATE", val);
  },
  set_popup_state({ commit }, val) {
    commit("SET_POPUP_STATE", val);
  },
  set_video_popup({ commit }, val) {
    commit("SET_VIDEO_POPUP", val);
  },

  set_image_popup({ commit }, val) {
    commit("SET_IMAGE_POPUP", val);
  },
  set_slideshow_popup({ commit }, val) {
    commit("SET_SLIDESHOW_POPUP", val);
  },
  set_links_popup({ commit }, val) {
    commit("SET_LINKS_POPUP", val);
  },
  set_contact_popup({ commit }, val) {
    commit("SET_CONTACT_POPUP", val);
  },
  set_unity_progress({ commit }, val) {
    commit("SET_UNITY_PROGRESS", val);
  },
  set_unity_info({ commit }, val) {
    commit("SET_UNITY_INFO", val);
  },
  set_current_section({ commit }, val) {
    commit("SET_ACTIVE_SECTION", val);
  },
  set_current_subsection({ commit }, val) {
    commit("SET_ACTIVE_SUB_SECTION", val);
  },
  //should have val.section and val.sub_section
  set_secondary_section({ commit }, val) {
    commit("SET_SECONDARY_SECTION", val);
  },
  set_app_state({ commit }, val) {
    commit("SET_APP_STATE", val);
  },
  set_simple_val({ commit }, obj) {
    commit("SET_SIMPLE_VAL", obj);
  },
  set_browser_identity({ commit }, obj) {
    commit("SET_BROWSER_IDENTITY", obj);
  },
  set_voiceover_played({ commit }, obj) {
    commit("SET_VOICEOVER_PLAYED", obj);
  },
  submit_form({ commit }, data) {
    if ("undefined" != typeof data.skip_form && data.skip_form == true) {
      commit("SAVE_INITIAL_MOVEMENT_FORM", data.app_mode);
      commit("SET_FORM_STATUS", 1);
      setTimeout(
        function () {
          commit("SET_FORM_STATUS", 2);
          commit("SET_PAGE_STATE", 2);
        }.bind(this),
        2000
      );
      return;
    }

    const axios = require("axios");

    commit("SET_FORM_STATUS", 1);
    commit("SAVE_BOOTH_FORM", data);
    commit("SAVE_INITIAL_MOVEMENT_FORM", data.app_mode);
    let axiosConfig = {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      "Access-Control-Allow-Origin": "*"
    };

    axios({
      method: "post",
      url: "/form.php",
      // url: "https://audentes.protoexpo.com/form.php",
      headers: {
        "Content-Type": "application/json"
      },
      data: data
    })
      .then(function (response) {
        commit("SET_FORM_STATUS", 2);
        commit("SET_PAGE_STATE", 2);
      })
      .catch(function (error) {
        console.log(error);
        commit("SET_FORM_STATUS", 2);
        commit("SET_PAGE_STATE", 2);
      });
  },
  set_contact_form_status({ commit }, data) {
    commit("SET_CONTACT_FORM_STATUS", data);
  },

  submit_photo_data({ commit }, data) {
    const axios = require("axios");
    const config = {
      headers: { "content-type": "multipart/form-data" }
    };
    console.log(data);
    return new Promise((resolve, reject) => {
      axios
        .post("/", data, config)
        .then((response) => {
          console.log(response.data);
          resolve();
        })
        .catch((error) => reject());
    });
  },

  submit_contact_form({ commit }, data) {
    const axios = require("axios");

    commit("SET_CONTACT_FORM_STATUS", 1);
    // setTimeout(() => {
    //   commit("SET_CONTACT_FORM_STATUS", 2);
    // }, 4000);

    axios({
      method: "post",
      url:
        "https://supernus.protoexpo.com/contactform/process-contact-form.php",
      // url: "http://100.50.20.65/contact/data",
      headers: {
        "Content-Type": "application/json"
      },
      data: data
    })
      .then(function (response) {
        commit("SET_CONTACT_FORM_STATUS", 2);
      })
      .catch(function (error) {
        console.log(error);
        commit("SET_CONTACT_FORM_STATUS", 3);
      });
  }
};

const getters = {
  appBarSections: (state) => {
    return state.sections.filter((section) => section.display_in_bar);
  },
  footerBarSections: (state) => {
    return state.sections.filter((section) => section.display_in_footer);
  },
  getSection: (state) => {
    return (section_id) => {
      let section = null;
      state.sections.forEach((item) => {
        if (item.id == section_id) {
          section = item;
        }
      });
      return section;
    };
  },
  sectionContent: (state) => {
    return (section_id) => {
      return state.sections_content[section_id];
    };
  },
  sectionCount: (state) => {
    return state.sections.length;
  },
  eventTag: (state) => {
    return state.sections_content.event_info.tag;
  }
};

Vue.use(Vuex);

export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters,
  strict: process.env.NODE_ENV !== "production"
});



// WEBPACK FOOTER //
// ./src/store/index.js